// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__zIn0G","line":"Divider_line__Oj0k0","notch":"Divider_notch__ZbSCe"};